const posterMaker = localStorage.getItem('TeamId') === 8 || localStorage.getItem('TeamId') === 9
    ? 'https://classplusapp.com/gold-rush-sale'
    : localStorage.getItem('TeamId') === 3 ||
      localStorage.getItem('TeamId') === 4 ||
      localStorage.getItem('TeamId') === 5
    ? 'https://classplusapp.com/weekendBonanza'
    : 'https://classplusapp.com/big-summer-sale';

export const playLists = [
  {
    name: 'How to increase your app downloads?',
    image:
      'https://cdn-cp-assets-public.classplus.co/campaignManager/YazIuEGnL9RZSBg2',
    url: {
      screen: 'UTIL_BROWSER',
      paramOne:
        'https://www.youtube.com/watch?v=BsDQ8gp4g1s&list=PL1AInJ3odbpmgroDv97xt5SkJteJH27-b',
      paramTwo: '',
      paramThree: '',
    },
  },
  {
    name: 'How to boost your revenue?',
    image:
      'https://cdn-cp-assets-public.classplus.co/campaignManager/NXMQNRRlS4iTSJNS',
    url: {
      screen: 'UTIL_BROWSER',
      paramOne:
        'https://www.youtube.com/watch?v=Da1vs8i0Z_E&list=PL1AInJ3odbpnk1v4UwWpWMt6_Pm7ERBx0',
      paramTwo: '',
      paramThree: '',
    },
  },
  {
    name: 'How to keep your store updated?',
    image:
      'https://cdn-cp-assets-public.classplus.co/campaignManager/qe4i4-pOFj611Lzk',
    url: {
      screen: 'UTIL_BROWSER',
      paramOne:
        'https://www.youtube.com/playlist?list=PL1AInJ3odbpkCMQy2S6WVaAGOT7_Qdbds',
      paramTwo: '',
      paramThree: '',
    },
  },
  {
    name: 'How to Go LIVE on your Store courses easily!',
    image:
      'https://cdn-cp-assets-public.classplus.co/campaignManager/tT_wGIeDSWz3u1N_',
    url: {
      screen: 'UTIL_BROWSER',
      paramOne: 'https://www.youtube.com/watch?v=BUt11ROoGUU',
      paramTwo: '',
      paramThree: '',
    },
  },
];
